/*********************************************************************************************
* Active container et gestion des dropdowns
	*
*/
document.addEventListener("DOMContentLoaded", function() {
	// Pour chaque section FAQ sur la page
	document.querySelectorAll(".mm-page-faq").forEach(function(section) {
		const filters = section.querySelectorAll(".mm-page-faq-tabs-title");
		const faqContents = section.querySelectorAll(".mm-faq-dropdown-wrapper[data-tab-content]");

		// Gestion des tabs
		if (filters.length > 0 && faqContents.length > 0) {
			filters[0].classList.add("active");
			faqContents[0].classList.add("active");
		}

		filters.forEach((filter) => {
			filter.addEventListener("click", function() {
				const tabIndex = filter.getAttribute("data-tab");
				
				// Remove active from all tabs and contents
				filters.forEach(f => f.classList.remove("active"));
				faqContents.forEach(content => content.classList.remove("active"));

				// Add active to clicked tab and corresponding content
				filter.classList.add("active");
				const correspondingContent = section.querySelector(`.mm-faq-dropdown-wrapper[data-tab-content="${tabIndex}"]`);
				if (correspondingContent) {
					correspondingContent.classList.add("active");
				}
			});
		});

		// Gestion des dropdowns individuels
		const dropdowns = section.querySelectorAll(".mm-faq-dropdown");
		dropdowns.forEach((dropdown) => {
			const header = dropdown.querySelector("[data-header]");
			const content = dropdown.querySelector("[data-content]");
			
			if (header && content) {
				header.addEventListener("click", function() {
					const isOpen = dropdown.getAttribute("data-property-1") === "Open";
					const iconContainer = header.querySelector(".mm-icon-container");
					
					if (isOpen) {
						dropdown.setAttribute("data-property-1", "Closed");
						dropdown.classList.remove("active");
						header.setAttribute("aria-expanded", "false");
						// Changer l'icône vers plus
						if (iconContainer) {
							iconContainer.innerHTML = `
								<svg class="mm-icon-plus" style="width: 16px; height: 16px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 5V19M5 12H19" stroke="var(--black-900)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							`;
						}
					} else {
						dropdown.setAttribute("data-property-1", "Open");
						dropdown.classList.add("active");
						header.setAttribute("aria-expanded", "true");
						// Changer l'icône vers moins
						if (iconContainer) {
							iconContainer.innerHTML = `
								<svg class="mm-icon-minus" style="width: 16px; height: 16px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M5 12H19" stroke="var(--black-900)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							`;
						}
					}
				});

				// Gestion du clavier
				header.addEventListener("keydown", function(e) {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						header.click();
					}
				});
			}
		});
	});
});
